import React, { createContext, PropsWithChildren, useState } from "react";
import { Basket } from "@utilities/types";

interface BasketContextType {
    baskets: Basket[];
    setBaskets: React.Dispatch<React.SetStateAction<Basket[]>>;
    activeBasket: Basket | null;
    setActiveBasket: React.Dispatch<React.SetStateAction<Basket | null>>;
}

export const BasketContext = createContext<BasketContextType>({
    baskets: [],
    setBaskets: () => { },
    activeBasket: null,
    setActiveBasket: () => { },
});

export const BasketContextProvider: React.FC<PropsWithChildren> = ({ children }) => {

    const [baskets, setBaskets] = useState<Basket[]>([]);
    const [activeBasket, setActiveBasket] = useState<Basket | null>(null);

    return (
        <BasketContext.Provider 
            value={{ 
                baskets, setBaskets,
                activeBasket, setActiveBasket,
            }}
        >
            {children}
        </BasketContext.Provider>
    );
};
